
import React, { useState, useEffect } from 'react';

// --- آیکون‌های مورد نیاز برای این کامپوننت ---
const Icons = {
  List: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>,
  Search: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
  Download: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>,
  ChevronLeft: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M15 19l-7-7 7-7" /></svg>,
};

// --- داده‌های دروس ---


export default function Handbook() {
    const [activeCourseId, setActiveCourseId] = useState(null);
    const [courseSearch, setCourseSearch] = useState('');
    // اضافه کردن استیت برای دریافت اطلاعات از دیتابیس
    const [coursesData, setCoursesData] = useState([]); 

    // دریافت اطلاعات دروس از API
    useEffect(() => {
        // حتما آدرس API خود را با آدرس زیر جایگزین کنید (مثلاً https://daneshesaze.com/api/handbooks.php)
        fetch('https://daneshesaze.com/api/handbooks.php')
            .then(res => res.json())
            .then(data => {
                setCoursesData(data);
                if (data.length > 0) {
                    setActiveCourseId(data[0].id); // نمایش خودکار اولین درس
                }
            })
            .catch(err => console.error("خطا در دریافت جزوات:", err));
    }, []);

    const getFilteredCourses = () => {
        if (!courseSearch) return coursesData;
        return coursesData.filter(c => c.title.toLowerCase().includes(courseSearch.toLowerCase()));
    };

    const filteredCourses = getFilteredCourses();
    const activeCourseData = coursesData.find(c => c.id === activeCourseId);
    
    // ... بقیه کدهای return () بدون تغییر باقی می‌مانند ...

    return (
        <div className="container mx-auto px-4 py-8 animate-fadeIn">
            <h1 className="text-4xl font-bold text-center mb-10 text-slate-800">جزوات درسی و منابع آموزشی</h1>
            <div className="flex flex-col lg:flex-row gap-6 min-h-[600px]">
                {/* Sidebar - لیست دروس */}
                <div className="w-full lg:w-[30%] flex-shrink-0">
                    <div className="sticky top-24 glass-card rounded-[53px] shadow-lg overflow-hidden flex flex-col h-[calc(100vh-150px)] max-h-[800px]">
                        <div className="p-4 border-b border-slate-200/50">
                            <h3 className="text-lg font-bold text-slate-700 flex items-center gap-2">
                                <Icons.List className="text-blue-600" />
                                فهرست دروس
                            </h3>
                        </div>
                        <div className="p-4 border-b border-slate-100/50">
                            <div className="relative">
                                <input 
                                    className="w-full pl-4 pr-10 py-2 rounded-[20px] bg-[#f0f0f3] shadow-neu-inset focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition-all"
                                    placeholder="جستجو در لیست دروس..."
                                    value={courseSearch}
                                    onChange={(e) => setCourseSearch(e.target.value)}
                                />
                                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400">
                                    <Icons.Search className="" />
                                </div>
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto custom-scrollbar p-3 space-y-2">
                            {filteredCourses.map(course => (
                                <button 
                                    key={course.id}
                                    onClick={() => setActiveCourseId(course.id)}
                                    className={`w-full text-right p-4 rounded-[20px] transition-all duration-300 flex items-center justify-between group course-nav-btn mb-2 ${activeCourseId === course.id ? 'active' : ''}`}
                                >
                                    <span className={`text-sm md:text-base font-medium ${activeCourseId === course.id ? 'text-blue-800 font-bold' : 'text-slate-700 group-hover:text-blue-800'}`}>
                                        {course.title}
                                    </span>
                                    {activeCourseId === course.id && <Icons.ChevronLeft className="text-blue-600" />}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Main Content - محتوای درس */}
                <div className="w-full lg:w-[70%]">
                    <div className="glass-card rounded-[53px] shadow-xl p-6 md:p-10 min-h-full relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-full h-1.5 bg-gradient-to-l from-blue-600 to-cyan-400"></div>
                        <div className="relative z-10">
                            {activeCourseData ? (
                                <div className="animate-fadeInScale">
                                    <div className="flex items-center gap-4 mb-6">
                                        <span className="w-1.5 h-8 bg-blue-600 rounded-full"></span>
                                        <h2 className="text-2xl md:text-3xl font-bold text-slate-800">{activeCourseData.title}</h2>
                                    </div>
                                    <div className="bg-transparent rounded-[20px] p-5 shadow-neu-inset mb-8">
                                        <p className="text-slate-700 leading-relaxed">{activeCourseData.description}</p>
                                    </div>
                                    <h4 className="text-lg font-bold text-slate-700 mb-4 flex items-center gap-2">فایل‌های قابل دانلود</h4>
                                    <div className="grid gap-3">
                                        {activeCourseData.links.length > 0 ? activeCourseData.links.map((link, i) => (
                                            <a key={i} href={link.url} target="_blank" rel="noreferrer" className="download-link-item group">
                                                <span>{link.title}</span>
                                                <Icons.Download className="h-6 w-6 text-blue-500 group-hover:scale-110 transition-transform" />
                                            </a>
                                        )) : (
                                            <p className="text-slate-500 text-sm">فایلی برای این درس موجود نیست.</p>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center text-gray-500 mt-20">
                                    لطفا یک درس را از منوی سمت راست انتخاب کنید.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}